import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { indexStore } from "../../store/indexStore";
import { IMG_URl } from "../../common/img_url";
import { useTranslation } from "react-i18next";
import { DarkModeTogle } from "../langSelect/DarkModeTogle";
import Iterator from "../utils/Iterator";
import { Skeleton } from "../ui/skeleton";
import Visibility from "../utils/Visibility";

import SearchField from "../Searchfield/ SearchField";
import { getRecentlyViewed } from "../utils/RecentlyViewed";
import RecentlyViewed from "./Recently/RecentlyViewed";
import MenuModel from "../../Models/MenuModel";
import BranchModel from "../../Models/BranchModel";
import ProductModel from "../../Models/PorductModel";

function NewBranchScreen() {
  const { menus, branch, restaurant, loading, name, description } =
    indexStore();
  const naivgate = useNavigate();
  const onClickMenu = (id: number | string) => {
    naivgate(`${id}`);
  };
  const onRecentlyClick = (item: ProductModel) => {
    naivgate(`${item.menu_id}/${item.id}`);
  };
  const params = useParams();
  const recentlyViewed = getRecentlyViewed(Number(params.branch_id));

  const { t } = useTranslation();

  const descriptionKey: keyof BranchModel =
    description === "description_ar" ? "description_ar" : "description_en";
  const formattedDescription = (branch?.[descriptionKey] ?? "").replace(
    /\n/g,
    "<br/>"
  );
  return (
    <>
      <Visibility visible={!loading}>
        <div className="bg-primary flex flex-col flex-grow gap-5 min-h-screen">
          {/* Header Section */}
          <div className="bg-foreground/60 shrink-0 text-onPrimary mx-4 rounded-2xl p-4 mt-4 flex items-stretch gap-1 opacity-0 animate-fadeIn">
            <div className="w-32 h-32 p-2 rounded-md shadow-md">
              <img
                className="w-full h-full aspect-square object-cover rounded-md"
                src={`${IMG_URl}${restaurant.logo}`}
                alt="logo"
              />
            </div>
            <h6
              className="leading-6 capitalize text-sm text-center font-semibold"
              dangerouslySetInnerHTML={{ __html: formattedDescription }}
            ></h6>
          </div>

          {/* Search */}
          <div className="flex gap-2 md:gap-3 items-center px-4 opacity-0 animate-[fadeIn_0.3s_ease-out_0.2s_forwards]">
            <div className="flex-1">
              <SearchField />
            </div>
            <button className="bg-background rounded-full p-2.5 md:p-3 shadow-md hover:shadow-lg hover:bg-muted transition-all duration-300">
              <DarkModeTogle showText={false} />
            </button>
          </div>

          {/* Menu Grid */}
          <div className="flex-1 flex-col flex gap-3 justify-between bg-background text-foreground rounded-t-[2rem] px-4 pt-4 pb-24 opacity-0 animate-[fadeIn_0.3s_ease-out_0.3s_forwards]">
            <div className="flex flex-col gap-3 opacity-0 animate-[fadeIn_0.3s_ease-out_0.4s_forwards]">
              <h2 className="text-lg md:text-xl font-semibold">
                {t("gloabl.menus")}
              </h2>
              <div className="grid grid-cols-3 gap-3 md:gap-4">
                <Iterator
                  data={menus}
                  render={(item: MenuModel, i) => (
                    <div
                      key={item.id || i}
                      className="text-center flex flex-col gap-1.5 cursor-pointer opacity-0 animate-fadeInUp transition-all duration-300 hover:scale-105"
                      style={{
                        animationDelay: `${
                          Math.floor(i / 3) * 100 + (i % 3) * 30
                        }ms`,
                      }}
                      onClick={() => onClickMenu(item.id)}
                    >
                      <img
                        src={`${IMG_URl}${item.image}`}
                        alt={item.name_en}
                        className="rounded-xl object-cover h-24 md:h-36 w-full shadow-md hover:shadow-lg transition-shadow"
                      />
                      <p className="text-xs md:text-sm font-semibold text-foreground">
                        {item[name as keyof MenuModel]}
                      </p>
                    </div>
                  )}
                />
              </div>
            </div>
            <div className="flex justify-between gap-4 flex-col mt-4">
              <h2 className="text-lg md:text-xl font-semibold">
                {t("gloabl.recently")}
              </h2>

              <RecentlyViewed
                recentlyViewed={recentlyViewed}
                onRecentlyClick={onRecentlyClick}
                IMG_URl={IMG_URl}
                name={name as keyof ProductModel}
              />
            </div>
          </div>
        </div>
      </Visibility>
      <Visibility visible={loading}>
        <RenderLoading />
      </Visibility>
    </>
  );
}

export default NewBranchScreen;
const RenderLoading = () => {
  return (
    <>
      <div className=" flex flex-col flex-grow gap-5 min-h-screen ">
        {/* <Header noBack={true} /> */}
        <Skeleton className=" bg-opacity-60 mx-4 rounded-2xl p-4 mt-4 flex justify-between items-start">
          <Skeleton className="w-36 h-36 p-4 rounded-md shadow-md"></Skeleton>
          <div className="flex flex-col gap-2">
            <Skeleton className={"w-36 h-6"} />
            <Skeleton className={"w-36 h-6"} />
          </div>
        </Skeleton>

        <div className="flex gap-2 items-center px-4 ">
          <Skeleton className={"w-full h-11 rounded-full"} />
          <Skeleton className={"w-11 h-11 rounded-full"} />
        </div>

        <Skeleton className="flex-1 flex-col flex gap-4 bg-opacity-50 rounded-t-[2rem] px-4 pt-4 pb-24">
          <Skeleton className={"w-24 h-6"} />
          <div className={`grid grid-cols-3  md:grid-cols-3 gap-5 `}>
            <Iterator
              data={[1, 2, 3, 4, 5, 6]}
              render={() => (
                <div>
                  <Skeleton className={` w-full h-28 rounded-xl md:h-36  `} />
                </div>
              )}
            />
          </div>
          <Skeleton className={"w-24 h-6"} />

          <div className="flex justify-between items-center gap-5  ">
            <Iterator
              data={[1, 2, 3]}
              render={() => (
                <Skeleton className={` w-full h-28 rounded-xl md:h-36  `} />
              )}
            />
          </div>
        </Skeleton>
      </div>
    </>
  );
};
